import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
	state:{
		//存放的键值对就是所要管理的状态
		is_logged_in: localStorage.getItem('tb_token') ? true : false,
		user_info: localStorage.getItem('tb_user_name') ? localStorage.getItem('tb_user_name') : null,
	},
	getters: {
		is_logged_in: state => state.is_logged_in,
		user_info: state => state.user_info,
	},
	actions: {
		login({ commit }, userData) {
			// 这里使用 API 登录，然后提交 mutation
			commit('SET_LOGIN_STATE', { is_logged_in: true,user_info: userData });
		},
		logout({ commit }) {
			// 这里使用 API 登出，然后提交 mutation
			commit('SET_LOGIN_STATE', { is_logged_in: false,user_info: null });
		},
		
	},
	mutations: {
		SET_LOGIN_STATE(state, payload) {
			state.is_logged_in = payload.is_logged_in;
			state.user_info = payload.user_info;
		},
		
	}
})

export default store